import React, { useRef, useState, useEffect } from "react";

import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import { API } from "aws-amplify";
import { Box } from "@mui/system";
import "./liveSession.css";

import {
  HeadingPrimary,
  HeadingSecondary,
} from "../../components/Styles/Heading";
import { Paper, Skeleton } from "@mui/material";

import { CustomButton } from "../../components/CustomButton/CustomButton";

// import { useSelector } from "react-redux";

import AppBarLandingPage from "../../components/AppBar/AppBar.landingPage";
import moment from "moment";

import config from "../../config/aws-exports";
import { useQueryParams } from "../../Hooks/useQueryParams";

import SpeakerDialog from "../LiveSession/SpeakerDialog";
import { ArrowLeft } from "@mui/icons-material";
import SignInAndSignUp from "../../components/SignInAndSignUp/SignInAndSignUp";

const PreLoginLiveSession = () => {
  //     const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const userDetails = useSelector(authData);

  const [loginOpen, setLoginOpen] = useState(false);
  const onlySignUp = useRef(false);
  //const sessionData = useSelector((state) => state.sessionData.value);

  const [openSpeaker, setSpeaker] = useState(false);

  const [speakerDetails, setSpeakerDetails] = useState({});
  const [regButton, setRegButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [sessionData, setSessionData] = useState({});
  const query = useQueryParams();
  const sid = query.get("sid");

  useEffect(() => {
    async function getsession() {
      const bodyParam = {
        body: {
          sid: sid,
          schema: config.schema,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };

      setIsLoading(true);
      try {
        const response = await API.post(
          config.aws_cloud_logic_custom_name,
          "/getSessionDetails",
          bodyParam,
        );
        const { sData } = response;

        setSessionData(sData);
        console.log("sData", sData);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        console.error(err);
      }
    }
    getsession();
  }, [sid]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    // const curTime = sessionData?.currentTime;
    const startTime = sessionData?.date_list?.[0].combineStartTime;
    if (moment().isAfter(moment(startTime))) {
      setRegButton(false);
    }
  }, [sessionData]);

  const handleClickSpeakerOpen = async (details) => {
    setSpeaker(true);
    setSpeakerDetails(details);
  };

  const handleLoginClickOpen = (prop) => () => {
    if (prop === "login") {
      setLoginOpen(true);
      onlySignUp.current = false;
    } else {
      setLoginOpen(true);
      onlySignUp.current = true;
    }
  };

  function Loader() {
    return (
      <Box sx={{ width: "100%" }}>
        <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
          {" "}
          <Skeleton variant="rectangular" width="70vw" height={200} />
          <Skeleton variant="rectangular" width="30vw" height={200} />
        </Box>
        <Skeleton variant="rectangular" width="100%" height={200} />
      </Box>
    );
  }

  return (
    <>
      <AppBarLandingPage handleLoginClick={handleLoginClickOpen} />

      <Stack spacing={2} margin="3rem">
        <Link to="/" style={{ display: "flex" }}>
          <div>
            <ArrowLeft />
          </div>
          <div>Back</div>
        </Link>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <HeadingPrimary>{sessionData?.sn}</HeadingPrimary>
        </Stack>
        <Stack
          direction={{ xs: "column-reverse", md: "row" }}
          spacing={{ xs: 1, md: 4 }}
        >
          <Paper
            elevation={5}
            sx={{
              p: 3,
              borderRadius: "4px",
              textAlign: "justify",
              width: "100%",
            }}
          >
            {sessionData?.birac_status && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <img
                  src={`https://${
                    config.aws_cloudfront_url
                  }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/ministryofsciencelogo.png`}
                  alt="logo"
                  height="60"
                />
                <img
                  src={`https://${
                    config.aws_cloudfront_url
                  }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/logo-dark.png`}
                  alt="logo"
                  height="60"
                />
                <img
                  src={`https://${
                    config.aws_cloudfront_url
                  }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/BIRAC_logo_new.png`}
                  alt="logo"
                  height="60"
                />
              </div>
            )}
            <Stack direction="row">
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={2}
                sx={{ flexGrow: 1 }}
              >
                <HeadingSecondary>
                  {sessionData?.date_list && (
                    <table className="tableStyle">
                      <tbody>
                        <tr>
                          <td style={{ verticalAlign: "top" }}>
                            <HeadingSecondary>
                              Session Date & Time :
                            </HeadingSecondary>
                          </td>

                          {sessionData?.date_list?.map((item) => {
                            return (
                              <tr>
                                <td>
                                  {moment(item.combineStartTime).format(
                                    "DD/MM/YYYY",
                                  )}
                                  <span style={{ marginLeft: "5px" }}></span>;
                                  <span style={{ marginLeft: "5px" }}></span>
                                  {moment(item.combineStartTime).format("LT")}
                                  <span style={{ marginLeft: "5px" }}></span>-
                                  <span style={{ marginLeft: "5px" }}></span>
                                  {moment(item.combineEndTime).format("LT")}
                                </td>
                              </tr>
                            );
                          })}
                        </tr>
                      </tbody>
                    </table>
                  )}
                </HeadingSecondary>
              </Stack>

              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={2}
                sx={{ flexGrow: 1 }}
              >
                <table
                  id="liveSession"
                  style={{
                    textAlign: "left",
                    borderCollapse: "separate",
                    borderSpacing: "10px 10px",
                  }}
                >
                  <tr>
                    <td>Speaker &#58;</td>
                    <td>
                      <Link
                        to={`/prelogin?sid=${sid}`}
                        onClick={async () => {
                          handleClickSpeakerOpen(sessionData?.speakers[0]);
                        }}
                      >
                        {sessionData?.speakers &&
                          sessionData?.speakers?.length !== 0 &&
                          sessionData?.speakers[0].name}
                      </Link>
                    </td>
                  </tr>
                  {sessionData?.speakers?.map((speaker, idx) => {
                    let rightSpeaker = [];
                    if (idx !== 0) {
                      rightSpeaker.push(speaker);
                    }
                    return (
                      <React.Fragment key={idx}>
                        {rightSpeaker.map((sp, id) => (
                          <tr key={sp.id + "jsndf"}>
                            <td></td>
                            <td>
                              <Link
                                to={`/prelogin?sid=${sid}`}
                                onClick={() => {
                                  handleClickSpeakerOpen(sp);
                                }}
                              >
                                {sp?.name}
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    );
                  })}

                  {(sessionData?.priceinr > 0 || sessionData?.priceusd) > 0 &&
                    (sessionData?.paid === true ||
                      sessionData?.paid === "true") && (
                      <tr>
                        <td>Fees &#58;</td>
                        <td>
                          <p style={{ textAlign: "left" }}>
                            {" "}
                            INR {sessionData?.priceinr} + GST / $
                            {sessionData?.priceusd}{" "}
                          </p>
                        </td>
                      </tr>
                    )}

                  {sessionData?.earlypriceinr &&
                    sessionData?.earlypriceusd &&
                    (sessionData?.earlypriceinr > 0 ||
                      sessionData?.earlypriceusd > 0) &&
                    sessionData?.earlydate &&
                    (sessionData?.paid === true ||
                      sessionData?.paid === "true") && (
                      <tr>
                        <td>Early Bird Offer &#58;</td>
                        <td>
                          <p style={{ textAlign: "left" }}>
                            INR {sessionData?.earlypriceinr ?? ""} + GST
                            {sessionData?.earlypriceusd > 0 && (
                              <>
                                /{" "}
                                <Box component="span" sx={{ mx: 0.3 }}>
                                  {" "}
                                  USD{" "}
                                </Box>
                                {sessionData?.earlypriceusd ?? ""} till{" "}
                                {moment(
                                  parseInt(sessionData?.earlydate),
                                ).format("DD MMM YYYY")}
                              </>
                            )}
                          </p>
                        </td>
                      </tr>
                    )}

                  {sessionData?.perdis !== null &&
                    sessionData?.perdis > 0 &&
                    (sessionData?.paid === true ||
                      sessionData?.paid === "true") && (
                      <tr>
                        <td>Percentage Discount &#58;</td>
                        <td>
                          <p style={{ textAlign: "left" }}>
                            {sessionData?.perdis} %
                          </p>
                        </td>
                      </tr>
                    )}
                  {sessionData?.priceafterinr !== null &&
                    sessionData?.priceafterusd !== null &&
                    (sessionData?.priceafterinr > 0 ||
                      sessionData?.priceafterusd > 0) &&
                    sessionData?.perdis > 0 && (
                      <tr>
                        <td style={{ textAlign: "left" }}>
                          Price after Discount &#58;
                        </td>
                        <td>
                          <p>
                            INR {sessionData?.priceafterinr} + GST /{" "}
                            <Box component="span" sx={{ mx: 0.3 }}>
                              {" "}
                              USD{" "}
                            </Box>
                            {sessionData?.priceafterusd}{" "}
                          </p>
                        </td>
                      </tr>
                    )}
                  {sessionData?.stype !== null &&
                    sessionData?.note !== "null" &&
                    sessionData?.note !== "" && (
                      <tr>
                        <td>Note &#58;</td>
                        <td>
                          <p style={{ textAlign: "left" }}>
                            {sessionData?.note}
                          </p>
                        </td>
                      </tr>
                    )}
                </table>
              </Stack>
              {/* {sessionData?.birac_status && (
                <div
                  className="logos"

                  // style={{
                  //   display: "flex",
                  //   justifyContent: "flex-end",
                  //   gap: "10px",
                  // }}
                >
                  <img
                    src={`https://${
                      config.aws_cloudfront_url
                    }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/BIRAC_logo.png`}
                    alt="logo"
                    height="60"
                  />
                  <img
                    src={`https://${
                      config.aws_cloudfront_url
                    }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/logo-dark.png`}
                    alt="logo"
                    height="60"
                  />
                </div>
              )} */}
            </Stack>
            {regButton && (
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <CustomButton primary onClick={handleLoginClickOpen("login")}>
                  Register
                </CustomButton>
              </Stack>
            )}
          </Paper>

          <img
            src={`https://${
              config.aws_cloudfront_url
            }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
              sessionData?.sid
            }.png`}
            alt=""
            height="200"
            width="auto"
            style={{ borderRadius: "4px" }}
          />
        </Stack>
        <>
          <Paper elevation={5} sx={{ p: 3, mt: 2 }}>
            {sessionData?.lobj !== "null" &&
              sessionData?.sdesc !== "" &&
              sessionData?.sdesc !== null && (
                <>
                  <HeadingSecondary>Overview</HeadingSecondary>
                  {/* <p style={{ textAlign: 'left' }}>{sessionData?.sdesc}</p> */}

                  {(() => {
                    const cleanedHTML = sessionData?.sdesc
                      ?.replace(/<p><br><\/p>/g, "")
                      ?.replace(/<p>\s*<\/p>/g, "")
                      ?.replace(/<br\s*\/?>/g, "");

                    return (
                      <div
                        className="html-content"
                        dangerouslySetInnerHTML={{ __html: cleanedHTML }}
                      ></div>
                    );
                  })()}

                  {/* <div
                    style={{ textAlign: "left" }}
                    dangerouslySetInnerHTML={{
                      __html: sessionData?.sdesc,
                    }}
                  ></div> */}
                </>
              )}
            {sessionData?.lobj !== "null" &&
              sessionData?.lobj !== "" &&
              sessionData?.lobj !== null && (
                <>
                  <HeadingSecondary style={{ marginTop: "10px" }}>
                    Learning objectives :{" "}
                  </HeadingSecondary>
                  {/* <ul
                    style={{
                      margin: 0,
                      paddingLeft: '0',
                      listStylePosition: 'inside',
                      textAlign: 'left',
                    }}
                  >
                    {sessionData?.lobj
                      ?.split('\n')
                      .map(
                        (obj, idx) =>
                          obj.replace(/\s/g, '') !== '' && (
                            <li key={idx + 'sddgd'}>{obj}</li>
                          ),
                      )}
                  </ul> */}

                  {(() => {
                    const cleanedHTML = sessionData?.lobj
                      // ?.replace(/<p><br><\/p>/g, "")
                      // ?.replace(/<p>\s*<\/p>/g, "")
                      ?.replace(/<br\s*\/?>/g, "");

                    return (
                      <div
                        className="html-content"
                        dangerouslySetInnerHTML={{ __html: cleanedHTML }}
                      ></div>
                    );
                  })()}

                  {/* <div
                    style={{ textAlign: "left" }}
                    dangerouslySetInnerHTML={{
                      __html: sessionData?.lobj,
                    }}
                  ></div> */}
                </>
              )}
            {sessionData?.taudi !== "null" &&
              sessionData?.taudi !== "" &&
              sessionData?.taudi !== null && (
                <>
                  <HeadingSecondary style={{ marginTop: "10px" }}>
                    Target audience:{" "}
                  </HeadingSecondary>
                  {/* <ul
                    style={{
                      margin: 0,
                      paddingLeft: "0",
                      listStylePosition: "inside",
                      textAlign: "left",
                    }}
                  >
                    {sessionData?.taudi
                      ?.split("\n")
                      .map(
                        (obj, id) =>
                          obj.replace(/\s/g, "") !== "" && (
                            <li key={id + "sdf"}>{obj}</li>
                          ),
                      )}
                  </ul> */}

                  {(() => {
                    const cleanedHTML = sessionData?.taudi
                      ?.replace(/<p><br><\/p>/g, "")
                      ?.replace(/<p>\s*<\/p>/g, "")
                      ?.replace(/<br\s*\/?>/g, "");

                    return (
                      <div
                        className="html-content"
                        dangerouslySetInnerHTML={{ __html: cleanedHTML }}
                      ></div>
                    );
                  })()}

                  {/* <div
                    style={{ textAlign: "left" }}
                    dangerouslySetInnerHTML={{
                      __html: sessionData?.taudi,
                    }}
                  ></div> */}
                </>
              )}
          </Paper>
        </>
      </Stack>
      {openSpeaker && (
        <SpeakerDialog
          open={openSpeaker}
          setOpen={setSpeaker}
          speakerDetails={speakerDetails}
        />
      )}
      {loginOpen && (
        <SignInAndSignUp
          loginOpen={loginOpen}
          setLoginOpen={setLoginOpen}
          onlySingUp={onlySignUp}
          sid={sessionData.sid}
        />
      )}

      {isLoading && (
        <Stack spacing={2} margin="3rem" paddingBottom="3rem">
          <Loader />
        </Stack>
      )}
    </>
  );
};

// function Duration({ start, end }) {
//   var startTime = moment(start);
//   var endTime = moment(end);

//   var hoursDiff = endTime.diff(startTime, "hours");
//   // console.log("Hours:" + hoursDiff);

//   // var minutesDiff = endTime.diff(startTime, "minutes");
//   // console.log("Minutes:" + minutesDiff);

//   // var secondsDiff = endTime.diff(startTime, "seconds");
//   // console.log("Seconds:" + secondsDiff);
//   return `${hoursDiff}h`;
// }

export default PreLoginLiveSession;
